//#region src/logic/passkeyProof.ts
var e = 1e5, t = (t, n = Date.now()) => n - t < e, n = (e, t = Date.now()) => {
	if (!e) return 0;
	let n = Date.parse(e) - t;
	return Number.isFinite(n) && n > 0 ? Math.ceil(n / 1e3) : 0;
};
//#endregion
export { e as PASSKEY_PROOF_MAX_AGE_MS, t as isProofFresh, n as resendSecondsLeft };
